import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { TitreTexteCtaImage } from '@components/titre-texte-cta-image/models';
import { ButtonComponent } from '@shared/components/button';
import { ImageComponent } from '@shared/components/image';
import { SvgComponent } from '@shared/components/svg';
import { TitleComponent } from '@shared/components/title';
import { HandleHtmlLinksDirective } from '@shared/directives';

@Component({
  selector: 'app-titre-texte-cta-image',
  imports: [TitleComponent, ButtonComponent, ImageComponent, SvgComponent, HandleHtmlLinksDirective],
  templateUrl: './titre-texte-cta-image.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitreTexteCtaImageComponent extends AbstractDynamicComponent<TitreTexteCtaImage> {}
